	<!-- Recomanded Jobs OR Latest Jobs-->
<div class="viewreport pd-tb-2 mt-4">
		<div class="container">
        <div class="row">
			<h3 class="subheading flexcss">View my report</h3>
            <h4 class="subheading-5 ">Summary for Last 90 Days</h4>           
                <div class="col-lg-12 pd-tb-2 ps-3">   
                    <div class="row"> 
                        <div class="col-md-4 col-lg-3 col-sm-12">
                            <div class="card mb-4 ">
                                <div class="card-body flexbox-b  text-success">
                                    <div class="easypie mr-4">
                                        <span class="easypie-data "><img src="assets/images/ic_search_appear.svg"></span>
                                      
                                    </div>
                                    <div>
                                        <h3 class="font-strong ">{{reportData?.searchAppearance}}</h3>
                                        <div class="text-muted">Search Appearances</div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div class="col-md-3 col-lg-3 col-sm-12 px-2">
                            <div class="card mb-4 pink">
                                <div class="card-body text-primary flexbox-b">
                                    <div class="easypie  mr-4">
                                        <span class="easypie-data "><img src="assets/images/ic_view.svg"></span>
                                     
                                    </div>
                                    <div>
                                       
                                        <h3 class="font-strong">{{reportData?.profileView}}</h3>
                                        <div class="text-muted">Profile Views</div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div class="col-md-3 col-lg-3 col-sm-12">
                            <div class="card mb-4 lite">
                                <div class="card-body flexbox-b">
                                    <div class="easypie  mr-4">

                                        <span class="easypie-data"><img src="assets/images/ic_rec_action.svg"></span>
                                    </div>
                                    <div>
                                        <h3 class="font-strong">{{reportData?.recruiterAction}}</h3>
                                        <div class="text-muted">Recruiter Actions</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>    
        <!--appeared search  -->
         <h4 class="subheading-5">{{reportData?.searchAppearance}} Search Appearances</h4>                           
             <div class="row">
                    <div class="col-md-6 paddingrt">                     
                        <div class="apperance" *ngFor="let topSearch of reportData?.topSearchKeylist; let i = index;">
                            <h4>{{topSearch?.title}}</h4>
                            <p class="times">{{topSearch?.manyTime > 1 ? topSearch?.manyTime + " Times" :  topSearch?.manyTime +" Time"}} </p>
                        </div> 
                  </div>
            
                <div class="col-md-6">
                     <div class="graphdiv ibox">
                                
                                    <div class="ibox-head">
                                        <div class="ibox-title graphTitle"><img src="../../../assets/images/ic_grp_up_arrow.svg" *ngIf="appearData?.current > appearData?.last"> <img src="../../../assets/images/ic_grp_down_arrow.svg" *ngIf="appearData?.current < appearData?.last"> <span [ngClass]="appearData?.current > appearData?.last ? 'green' : appearData?.current < appearData?.last ? 'red':''">{{appearArowth}}%</span> <span *ngIf="daysFilter == '7Days'"> since week</span> <span *ngIf="daysFilter == '30Days'"> since 30 Days</span> <span *ngIf="daysFilter == '90Days'"> since 90 Days</span>  </div>
                                        <div class="ibox-tools">
                                            <ul>
                                                <li class="services">
                                                    <select class="form-control selectpicker" (click)="searchAppearanceFilter($event)">
                                                        <option value="7Days">7 Days</option>
                                                        <option value="30Days">30 Days</option>
                                                        <option value="90Days" selected>90 Days</option>
                                                   </select>
                                                 </li>
                                            </ul>
                                        </div>     
                                    </div>
                                    <div class="ibox-body">
                                        <div>
                                            <div id="chart-line"></div>
                                        </div>
                                    </div>
                                
                            </div>
                        </div>
              </div>   
            <h4 class="subheading-5">{{reportData?.profileView}} Profile Views</h4>    
            <div class="col-lg-12">
                <div class="graphdiv ibox">
                    <div class="ibox-head">
                        <div class="ibox-title graphTitle"><img src="../../../assets/images/ic_grp_up_arrow.svg" *ngIf="profileViewData?.current > profileViewData?.last"> <img src="../../../assets/images/ic_grp_down_arrow.svg" *ngIf="profileViewData?.current < profileViewData?.last"> <span [ngClass]="profileViewData?.current > profileViewData?.last ? 'green' : profileViewData?.current < profileViewData?.last ? 'red':''">{{growth}}% </span> <span *ngIf="daysFilter == '7Days'"> since week</span> <span *ngIf="daysFilter == '30Days'"> since 30 Days</span> <span *ngIf="daysFilter == '90Days'"> since 90 Days</span> </div>
                        <div class="ibox-tools">
                            <ul>
                                <li class="services">
                                     <select class="form-control selectpicker" (click)="profileFilter($event)" >
                                         <option value="7Days">7 Days</option>
                                         <option value="30Days">30 Days</option>
                                         <option value="90Days" selected>90 Days</option>
                                    </select>
                                 </li>
                            </ul>
                        </div>     
                    </div>
                    <div class="ibox-body">
                        <div id="chart-line2"></div>
                    </div>
                </div>
            
            </div>

            <div class="row">
                <h3 class="subheading-5 flexcss">Details
                    <a href="javascript:void(0);" class="orange text-small flexcss" routerLink="/employer-choice" [queryParams]="{ type: 'viewreport',filters:'view'}">See all <img src="assets/images/arrow.svg"></a></h3>    
                <!-- First Card -->
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12" *ngFor="let detail of profileViewData?.recrutier; let i=index;">
                            <div class="card-grid-2" (click)="openEmployerDetails(detail.recruiter?.id)">
                                <div class="card-grid-2-image-left">
                                    <div class="image-box"><img [src]="detail?.recruiter?.profileImage != null ? recruiterImagePath + detail?.recruiter?.profileImage :'../../../assets/images/profile-img.jpg'" alt="jobBox"></div>
                                        <div class="right-info">
                                            <a class="name-job">{{detail?.recruiter?.name}}</a>
                                            <span class="location-small">{{detail?.recruiter?.companyName}} | {{detail?.recruiter?.location}}</span>
                                            
                                        </div>
                                        <div class="arrow">
                                            <p class="times">{{dateInMilisecond(detail?.createdAt) |
                                                dateAgoConvertor}}</p>
                                        </div>
                                </div>
                            </div>
                        </div>     
            </div>   


            <div class="row">
                <div class="col-md-12">
                    <h3 class="subheading flexcss">{{reportData?.recruiterAction}} recruiter actions<a href="javascript:void(0);" class="orange text-small flexcss" routerLink="/employer-choice" [queryParams]="{ type: 'viewreport',filters:filter}">See all <img src="assets/images/arrow.svg"></a></h3>
                    <div class="pills">
                        <ul class="list-6">
                            <li class="{{filter=='All'?'active':''}}" (click)="onAction($event,1)"><a>All actions ({{recruiterData?.totalAllCount}})</a></li>
                            <li (click)="onAction($event,2)" class="{{filter=='view'?'active':''}}"><a>Profile viewed ({{recruiterData?.totalViewCount}})</a></li>
                            <li (click)="onAction($event,3)" class="{{filter=='download'?'active':''}}"><a>Resume downloaded ({{recruiterData?.totalDownloadCount}})</a></li>
                            <li (click)="onAction($event,4)" class="{{filter=='mail'?'active':''}}"><a>Connected by Email ({{recruiterData?.totalMailCount}})</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12" *ngFor="let action of recruiterData?.listing; let i=index;">
                    <div class="card-grid-2" *ngIf="i<6"  (click)="openEmployerDetails(action?.recruiter?.id)">
                        <div class="card-grid-2-image-left">
                            <div class="image-box"><img [src]="action?.recruiter?.profileImage != null ? recruiterImagePath + action?.recruiter?.profileImage :'../../../assets/images/profile-img.jpg'" alt="jobBox"></div>
                                <div class="right-info">
                                    <a class="name-job">{{action?.recruiter?.name || "-"}}</a>
                                    <span class="location-small">{{action?.recruiter?.companyName || "-"}} | {{action?.recruiter?.location || "-"}}</span>
                                    <p class="pink2">
                                        <span *ngIf="action.actionType == 0"> Profile viewed</span>
                                        <span *ngIf="action.actionType == 1">Resume downloaded </span>
                                        <span *ngIf="action.actionType == 2">Connected by email</span>
                                        <span *ngIf="action.actionType == 3">Favourite </span>
                                        <span *ngIf="action.actionType == 4">Hide </span>
                                    </p>
                                    
                                </div>
                                <div class="arrow">
                                    <p class="times">{{dateInMilisecond(action?.createdAt) |
                                        dateAgoConvertor}}</p>
                                </div>
                            
                        </div>
                    </div>
                </div> 
                
                <div class="col-md-12" *ngIf="recruiterData?.listing == 0">
                    <div class="noDataFound">
                        <h2>No records found</h2>
                    </div>
                </div> 
            </div>

            </div>
         </div>
   
</div>
           

  
	<!-- End -->
